import script from "./BuildersGrid.vue?vue&type=script&setup=true&lang=js"
export * from "./BuildersGrid.vue?vue&type=script&setup=true&lang=js"

import "./BuildersGrid.vue?vue&type=style&index=0&id=0f1d9208&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f1d9208"]])

export default __exports__